var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <li class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"disabled") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":15},"end":{"line":3,"column":46}}})) != null ? stack1 : "")
    + " page-item\"><a href=\"\" class=\"page-link\" data-attribute=\"p="
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"n") : depth0), depth0))
    + "\">Prev</a>\n    </li>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "disabled";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <li class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"active") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":15},"end":{"line":7,"column":42}}})) != null ? stack1 : "")
    + " page-item\"><a href=\"\" class=\"page-link\" data-attribute=\"p="
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"n") : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"n") : depth0), depth0))
    + "</a>\n    </li>\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "active";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <li class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"disabled") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":15},"end":{"line":11,"column":46}}})) != null ? stack1 : "")
    + " page-item\"><a href=\"\" class=\"page-link\" data-attribute=\"p="
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"n") : depth0), depth0))
    + "\">Next</a>\n    </li>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<ul class=\"pagination pagination-centered justify-content-center\">\n"
    + ((stack1 = __default(require("../helpers/paginate.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"pagination") : depth0),{"name":"paginate","hash":{"type":"previous"},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":5,"column":17}}})) != null ? stack1 : "")
    + ((stack1 = __default(require("../helpers/paginate.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"pagination") : depth0),{"name":"paginate","hash":{"limit":"5","type":"middle"},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":4},"end":{"line":9,"column":17}}})) != null ? stack1 : "")
    + ((stack1 = __default(require("../helpers/paginate.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"pagination") : depth0),{"name":"paginate","hash":{"type":"next"},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":4},"end":{"line":13,"column":17}}})) != null ? stack1 : "")
    + "</ul>";
},"useData":true});